import React, { useEffect, useState } from "react";
import { NavigationButton } from "../intro/objective";
import { getTestimonialsAPI } from "../../service/ai.service";
import { useAppContext } from "../../context/app.context";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const TrackRecord = () => {
    const [testimonials, setTestimonials] = useState([]);
    const { updateLoader } = useAppContext();
    const navigate = useNavigate();

    useEffect(() => {
        updateLoader(true)
        getTestimonialsAPI()
            .then(result => setTestimonials(result))
            .finally(() => updateLoader(false))
    }, [])

    const renderCompanyList = () => {
        const sliderConfig = {
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
        };
        return (
            <Slider className="evaluationslider navigatorslider px-5" {...sliderConfig}>
                {testimonials.map((test, index) => (
                    <div class="recomm_content">
                        <p>{test.testimonial}</p>
                        <div class="auth_sec">
                            <h4 class=" font-weight-bold mb-2">{test.person}</h4>
                            <div class="text-blue mb-3">{test.title ? `${test.title}, ${test.company_name}` : test.company_name} </div>
                            <div class="auth_img"><img src={test.company_logo} width="150px" /></div>

                        </div>
                    </div>)
                )}
            </Slider>
        )
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.TRACK_RECORD}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/unique-diffs'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.UNIQUIE_DIFFERENTIATORS}</p></DisabledNavLink>
                    <DisabledNavLink to='/faq'><p className="m-0 p-0">{SECTION_NAMES.FAQS}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <div className="text-center mb-3 ai-th"><strong>Testimonials</strong></div>
            <div className="mt-5">
                {renderCompanyList()}
            </div>
            {/* <div style={{ textAlign: "center" }}>
                <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/unique-diffs')}></button>
                <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/faq')}></button>
            </div> */}

        </>
    );
};

export default TrackRecord;
